import { NavLink } from "react-router-dom";
import {
  FaLaptopCode,
  FaBullhorn,
  FaMobileAlt,
  FaPencilRuler,
  FaPalette,
  FaSearch,
} from "react-icons/fa";

function SectionWhyChooseUs1() {
  return (
    <>
      <div
        className="section-full sx-why-chooseus-outer sx-bg-light bg-cover mb-5"
        style={{
          //   backgroundImage: `url(${publicUrlFor("images/background/bg-1.jpg")})`,
          backgroundColor: "#e0f0f3",
        }}
      >
        <div
          className="container-fluid p-5"
          style={{
            backdropFilter: `blur(2px)`,
          }}
        >
          {/* TITLE START */}
          <div className="section-head center">
            {/* <div className="sx-head-s-title text-light">Why Choose Us</div> */}
            <div className="sx-head-l-title p-5 pb-2">
              <h2 className="sx-title">Our Professional Services</h2>
            </div>
          </div>
          {/* TITLE END */}

          <div className="section-content">
            <div className="sx-icon-bx-wrap">
              <div className="row">
                {/* Website Development */}
                <div className="col-lg-4 col-md-6 wow fadeInDown">
                  <div className="sx-icon-bx-1">
                    <div className="sx-icon-box-wraper">
                      <div className="sx-icon-bx-icon">
                        {/* <span className="sx-text-primary">
                          <i className="flaticon-programmer" />
                        </span> */}
                        <span className="sx-text-primary">
                          <FaLaptopCode size={40} />
                        </span>
                      </div>
                      <div className="icon-content">
                        <NavLink to="/services/web-development/">
                          <h4 className="sx-tilte">Website Development</h4>
                        </NavLink>
                        <p>
                          Custom, responsive, and scalable websites built to
                          enhance your brand presence and business growth.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mobile App Development */}
                <div className="col-lg-4 col-md-6 wow fadeInDown">
                  <div className="sx-icon-bx-1">
                    <div className="sx-icon-box-wraper">
                      <div className="sx-icon-bx-icon">
                        {/* <span className="sx-text-primary">
                          <i className="flaticon-data" />
                        </span> */}
                        <span className="sx-text-primary">
                          <FaMobileAlt size={40} />
                        </span>
                      </div>
                      <div className="icon-content">
                        <NavLink to="/services/mobile-app-development">
                          <h4 className="sx-tilte">Mobile App Development</h4>
                        </NavLink>
                        <p>
                          Android and iOS applications designed for seamless
                          user experience and scalability.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Digital Marketing */}
                <div className="col-lg-4 col-md-6 wow fadeInDown">
                  <div className="sx-icon-bx-1">
                    <div className="sx-icon-box-wraper">
                      <div className="sx-icon-bx-icon">
                        {/* <span className="sx-text-primary">
                          <i className="flaticon-chart" />
                        </span> */}
                        <span className="sx-text-primary">
                          <FaBullhorn size={40} />
                        </span>
                      </div>
                      <div className="icon-content">
                        <NavLink to="/services/digital-marketing">
                          <h4 className="sx-tilte">Digital Marketing</h4>
                        </NavLink>
                        <p>
                          Data-driven digital marketing strategies to increase
                          visibility, leads, and online conversions.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* UI/UX Design */}
                {/* <div className="col-lg-4 col-md-6 wow fadeInDown">
                  <div className="sx-icon-bx-1">
                    <div className="sx-icon-box-wraper">
                      <div className="sx-icon-bx-icon">
                        <span className="sx-text-primary">
                          <FaPencilRuler size={40} />
                        </span>
                      </div>
                      <div className="icon-content">
                        <NavLink to="/services/detail">
                          <h4 className="sx-tilte">UI / UX Design</h4>
                        </NavLink>
                        <p>
                          User-centric interface and experience design focused
                          on usability, aesthetics, and engagement.
                        </p>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* Graphic Designing */}
                {/* <div className="col-lg-4 col-md-6 wow fadeInDown">
                  <div className="sx-icon-bx-1">
                    <div className="sx-icon-box-wraper">
                      <div className="sx-icon-bx-icon">
              
                        <span className="sx-text-primary">
                          <FaPalette size={40} />
                        </span>
                      </div>
                      <div className="icon-content">
                        <NavLink to="/services/detail">
                          <h4 className="sx-tilte">Graphic Designing</h4>
                        </NavLink>
                        <p>
                          Creative and professional designs that strengthen
                          brand identity and visual communication.
                        </p>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* SEO */}
                {/* <div className="col-lg-4 col-md-6 wow fadeInDown">
                  <div className="sx-icon-bx-1">
                    <div className="sx-icon-box-wraper">
                      <div className="sx-icon-bx-icon">
                    
                        <span className="sx-text-primary">
                          <FaSearch size={40} />
                        </span>
                      </div>
                      <div className="icon-content">
                        <NavLink to="/services/detail">
                          <h4 className="sx-tilte">SEO Optimization</h4>
                        </NavLink>
                        <p>
                          Search engine optimization techniques to improve
                          rankings, traffic, and long-term online visibility.
                        </p>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionWhyChooseUs1;
